<template>
	<div class="custom-slider-wrapper">
		<input
			ref="slider"
			:value="value"
			class="slider"
			:class="{ disabled: disabled }"
			type="range"
			:max="max"
			:min="min"
			:step="step"
			:disabled="disabled"
			tabindex="-1"
			aria-hidden="true"
			@input="onChange($event.target.value)"
		/>
	</div>
</template>
<script>
export default {
	props: {
		max: {
			type: Number,
			default: 10
		},
		min: {
			type: Number,
			default: 1
		},
		step: {
			type: Number,
			default: 1
		},
		value: {
			type: Number,
			default: 10
		},
		changeHandler: {
			type: Function,
			default: () => {}
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			recommendedMinPosition: null,
			recommendedMaxPosition: null,
			showMinTooltip: this.showTooltips,
			showMaxTooltip: false,
			recommendationTickWidth: 12, //px
			sliderThumbWidth: 22 //px
		};
	},
	methods: {
		onChange(value) {
			this.changeHandler(value);
			this.$emit('input', parseInt(value));
		}
	}
};
</script>
<style lang="scss" scoped>
// excess height to improve interactive area / accessibility
$height: 30px;
$thumb-height: 22px;
$track-height: 4px;

$upper-background: linear-gradient(to bottom, $disabled-state, $disabled-state)
	100% 50% / 100% $track-height no-repeat transparent;
$lower-background: linear-gradient(to bottom, $primary-state, $primary-state)
	100% 50% / 100% $track-height no-repeat transparent;

$disabled-lower-background: linear-gradient(
		to bottom,
		$disabled-slider-lower-background,
		$disabled-slider-lower-background
	)
	100% 50% / 100% $track-height no-repeat transparent;

// Webkit cannot style progress so we fake it with a long shadow
// on the thumb element
@function webkit-slider-thumb-shadow($i: 1) {
	$val: #{$i}px 0 0 -#{($thumb-height - $track-height) / 2} #{$disabled-state};
	@if $i == 1 {
		@for $k from 2 through 1000 {
			$val: #{$val}, webkit-slider-thumb-shadow($k);
		}
	}
	@return $val;
}
.custom-slider-wrapper {
	position: relative;

	.slider {
		display: block;
		appearance: none;
		width: 100%;
		margin: 0;
		height: $height;
		overflow: hidden;
		background-color: transparent;
		cursor: pointer;

		&:focus {
			outline: none;
		}

		// Webkit
		&::-webkit-slider-runnable-track {
			width: 100%;
			height: $height;
			background: $lower-background;
		}

		&::-webkit-slider-thumb {
			position: relative;
			appearance: none;
			height: $thumb-height;
			width: $thumb-height;
			background: $primary-state;
			border-radius: 100%;
			border: 0;
			top: 50%;
			margin-top: calc(-1 * $thumb-height / 2);
			box-shadow: webkit-slider-thumb-shadow();
			transition: background-color 150ms;
		}

		// Firefox
		&::-moz-range-track,
		&::-moz-range-progress {
			width: 100%;
			height: $height;
			background: $upper-background;
		}

		&::-moz-range-progress {
			background: $lower-background;
		}

		&::-moz-range-thumb {
			appearance: none;
			margin: 0;
			height: $thumb-height;
			width: $thumb-height;
			background: $primary-state;
			border-radius: 100%;
			border: 0;
			transition: background-color 150ms;
		}

		// Edge
		&::-ms-track {
			width: 100%;
			height: $height;
			border: 0;
			color: transparent;
			background: transparent;
		}

		&::-ms-fill-lower {
			background: $lower-background;
		}

		&::-ms-fill-upper {
			background: $upper-background;
		}

		&::-ms-thumb {
			appearance: none;
			height: $thumb-height;
			width: $thumb-height;
			background: $primary-state;
			border-radius: 100%;
			border: 0;
			transition: background-color 150ms;
			top: 0;
			margin: 0;
			box-shadow: none;
		}
		@media (any-hover: hover) {
			&:hover {
				&::-webkit-slider-thumb {
					background-color: $hover-state;
				}
				&::-moz-range-thumb {
					background-color: $hover-state;
				}
				&::-ms-thumb {
					background-color: $hover-state;
				}
			}
		}

		&.disabled {
			cursor: default;

			&::-webkit-slider-runnable-track {
				background: $disabled-lower-background;
			}

			&::-moz-range-progress {
				background: $disabled-lower-background;
			}

			&::-ms-fill-lower {
				background: $disabled-lower-background;
			}

			&::-webkit-slider-thumb {
				background: transparent;
			}
			&::-moz-range-thumb {
				background: transparent;
			}
			&::-ms-thumb {
				background: transparent;
			}

			&:hover {
				&::-webkit-slider-thumb {
					background-color: transparent;
				}
				&::-moz-range-thumb {
					background-color: transparent;
				}
				&::-ms-thumb {
					background-color: transparent;
				}
			}
		}
	}
}
</style>
